<template>
  <div class="card-contact-person p-4 lg:p-8 flex flex-col gap-6 rounded-sm h-full">
    <div class="flex justify-center">
      <div
        v-if="image"
        class="card-contact-person-img mx-auto flex-shrink-0 w-full"
      >
        <ShieldMaskFull />
        <img
          :src="image"
          :alt="fullName"
        >
      </div>
    </div>
    <div class="card-contact-person-info flex flex-col items-center justify-end h-full">
      <div class="mb-auto">
        <h4
          v-if="fullName"
          class="card-contact-person-fullname text-center"
        >
          {{ fullName }}
        </h4>
        <p
          v-if="functionTitle"
          class="card-contact-person-functiontitle text-center text-xs mb-6 text-primary-alpha"
        >
          {{ functionTitle }}
        </p>
      </div>
      <a
        v-if="phoneNumber"
        :href="`tel:${phoneNumber}`"
        class="mb-0 text-primary-alpha hover:!no-underline"
      >
        {{ phoneNumber }}
      </a>

      <p
        v-if="emailAddress"
        class="card-contact-person-emailaddress "
      >
        <a
          class=""
          :href="`mailto:${emailAddress}`"
        >{{ emailAddress }}</a>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KfCardContactPerson',
  components: {
    ShieldMaskFull: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ShieldMaskFull.vue'),
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    fullName: {
      type: String,
      default: '',
    },
    functionTitle: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    emailAddress: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="postcss">
.card-contact-person {
  @apply shadow-md;

  &-img {
    @apply relative mx-auto flex;
    clip-path: url(#shape-blob-full);
    width: 150px;
    height: 150px;

    img {
      max-width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }
  }

  &-emailaddress {
    a {
      @apply text-primary-alpha underline hover:no-underline;
    }
  }
}
</style>
